import script from "./AddRouteSubscription.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddRouteSubscription.vue?vue&type=script&setup=true&lang=ts"

import "./AddRouteSubscription.vue?vue&type=style&index=0&id=b21e5d12&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b21e5d12"]])

export default __exports__